const css = require('sheetify');
const choo = require('choo');

require('babel-polyfill');

css('tachyons');
css('leaflet');
css('./assets/fonts.css');
css('./assets/main.css');

const app = choo();

if (process.env.NODE_ENV !== 'production') {
  app.use(require('choo-devtools')());
} else {
  // app.use(require('choo-service-worker')());
}

app.use(require('./stores/map'));

app.route('/*', require('./views/main'));
// app.route('/facility/:facility_id', require('./views/facility'));
// app.route('/*', require('./views/404'));

module.exports = app.mount('body');
